import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import StickyCtaBar from './components/StickyCtaBar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import FreedomDial from './components/FreedomDial';
import Reliability from './components/Reliability';
import ComponentsZigzag from './components/ComponentsZigzag';
import Platform from './components/Platform';
import CustomComponents from './components/CustomComponents';
import UseCasesNarrative from './components/UseCasesNarrative';
import SecurityGovernance from './components/SecurityGovernance';
import ConversionCTA from './components/ConversionCTA';
import CommunityCTA from './components/CommunityCTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PreviewImage from './components/PreviewImage';
import MetadataInfo from './components/MetadataInfo';
import Community from './pages/Community';
export function App() {
  useEffect(() => {
    // Title
    document.title = 'FluidWeb — Agentic Interfaces for Production Apps';
    // Helper to set or create meta tags
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    const description = 'Turn your UI into an execution surface for AI — with policies, approvals, and auditability built in. Drop-in agentic components for forms, navigation, data exploration, and actions.';
    // Primary meta
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', 'agentic UI, AI interfaces, React SDK, TypeScript, AI forms, AI navigation, AI actions, production AI, enterprise AI, FluidWeb');
    setMeta('name', 'author', 'FluidWeb, Inc.');
    setMeta('name', 'theme-color', '#f97316');
    // Open Graph
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', 'https://fluid-form.ai/');
    setMeta('property', 'og:title', 'FluidWeb — Agentic Interfaces for Production Apps');
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:site_name', 'FluidWeb');
    // Twitter Card
    setMeta('property', 'twitter:card', 'summary_large_image');
    setMeta('property', 'twitter:url', 'https://fluid-form.ai/');
    setMeta('property', 'twitter:title', 'FluidWeb — Agentic Interfaces for Production Apps');
    setMeta('property', 'twitter:description', description);
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/terms" element={<TermsOfUse data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/preview" element={<PreviewImage data-id="element-7" />} data-id="element-6" />
        <Route path="/metadata" element={<MetadataInfo data-id="element-9" />} data-id="element-8" />
        <Route path="/community" element={<Community data-id="element-11" />} data-id="element-10" />
        <Route path="/" element={<div className="w-full min-h-screen font-sans bg-white text-gray-900 selection:bg-orange-100 selection:text-orange-900" data-id="element-13">
              <Navbar data-id="element-14" />
              <StickyCtaBar data-id="element-15" />
              <div data-id="element-16">
                <Hero data-id="element-17" />
                <ProblemSection data-id="element-18" />
                <SolutionSection data-id="element-19" />
                <FreedomDial data-id="element-20" />
                <Reliability data-id="element-21" />
                <ComponentsZigzag data-id="element-22" />
                <Platform data-id="element-23" />
                <CustomComponents data-id="element-24" />
                <UseCasesNarrative data-id="element-25" />
                <SecurityGovernance data-id="element-26" />
                <ConversionCTA data-id="element-27" />
                <CommunityCTA data-id="element-28" />
                <FAQ data-id="element-29" />
                <Footer data-id="element-30" />
              </div>
            </div>} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}